module.exports = "/assets/66d9c695eb6549fa680e5effdc3046ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4O.png
// module id = 1041
// module chunks = 0